<template>
    <div :key="renderKey">
        <v-carousel
            light
            :height="height"
            :show-arrows="showArrows"
            :cycle="!$root.edit && cycle"
            :hide-delimiters="hideDelimiters"
            :hide-delimiter-background="hideDelimiterBackground"
            :interval="interval"
            v-model="currentItem"
        >
            <v-carousel-item
                v-for="item in items"
                :key="item.id"
            >
                <component-wrapper
                    :config="item"
                    :array="items"
                    can-remove
                />
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
import components from '../component.js';
import {omitBy} from 'lodash';
export default {
    name: 'zoezi-carousel',

    zoezi: {
        title: 'Slideshow',
        icon: 'mdi-view-carousel-outline'
    },

    props: {
        items: {
            title: 'Pages',
            type: Array,
            default: () => [components.makeEmptyConfig({})],
            fulltype: 'componentlist'
        },
        height: {
            title: 'Height',
            type: String,
            fulltype: 'csssize',
            default: '500px'
        },
        showArrows: {
            title: 'Show arrows',
            type: Boolean,
            default: true
        },
        cycle: {
            title: 'Automatically proceed to the next image',
            type: Boolean,
            default: false
        },
        interval: {
            title: 'Time before the next page is displayed (ms)',
            type: Number,
            default: 6000
        },
        hideDelimiters: {
            title: 'Hide buttons at the bottom',
            type: Boolean,
            default: false
        },
        hideDelimiterBackground: {
            title: 'Hide background at the bottom',
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        renderKey: 0,
        currentItem: 0
    }),
    methods: {
        save() {
            const props = omitBy(this.$props, v => v === undefined)
            this.$emit('save', props);
            this.renderKey++;
        },
        addItem() {
            this.items.splice(this.items.length, 0, {});
            this.save();
        },
        saveConfigForChild(item, config) {
            Object.assign(item.props, config);
            this.save();
        },
        findChild(id) {
            let index = this.items.findIndex(item => item.id == id);
            if (index != -1) {
                this.currentItem = index;
                ++this.renderKey;
            }
        }
    },
    migrations: [
        (props) => {
            if (typeof props.height !== 'string' && props.height) {
                props.height = props.height + 'px';
            }
        }
    ]
}
</script>
